"use client";

import { createContext, useContext } from "react";

import type { Hearing } from "@/lib/public-hearings/types";

type FocusContextValue = {
  focusedHearing: Hearing | null;
  setFocus: (hearing: Hearing) => void;
  clearFocus: () => void;
};

export const FocusContext = createContext<FocusContextValue>({
  focusedHearing: null,
  setFocus: () => {},
  clearFocus: () => {},
});

export const useFocus = () => useContext(FocusContext);
